import { render, staticRenderFns } from "./ImagePolygonViewer.vue?vue&type=template&id=4662fc1a&scoped=true"
import script from "./ImagePolygonViewer.vue?vue&type=script&lang=js"
export * from "./ImagePolygonViewer.vue?vue&type=script&lang=js"
import style0 from "./ImagePolygonViewer.vue?vue&type=style&index=0&id=4662fc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4662fc1a",
  null
  
)

export default component.exports